import { makeStyles } from "@material-ui/core";

interface IProps{
    ellipsis:boolean,
    shrink: boolean,
    wrapValue?: boolean,
}

export default makeStyles((theme) => ({
    label:{
        whiteSpace: 'nowrap',
        textOverflow: (props: IProps) => props.ellipsis ? 'ellipsis' : '',
        overflow: 'hidden',
    },
    container:{
        width: '100%',
        overflow: (props: IProps) => (props.wrapValue ? 'visible' : 'hidden'),
    },
    tooltip:{
        // 1% extra so tooltip still displays
        maxWidth: (props: IProps) => props.ellipsis ? props.shrink ? '126%' : '101%' : 'none',
        overflow:'hidden',
    },
    arrow:{
        left:"15px !important",
    },
    labelTypography:{
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    typography:{
        whiteSpace: (props: IProps) => (props.wrapValue ? 'pre-wrap' : 'nowrap'),
        textOverflow: (props: IProps) => (props.wrapValue ? 'clip' : 'ellipsis'),
        overflow: (props: IProps) => (props.wrapValue ? 'visible' : 'hidden'),
        wordBreak: (props: IProps) => (props.wrapValue ? 'break-word' : 'normal'),
        fontWeight: 500,
    },
    input:{
        textOverflow: 'ellipsis',
    },
    disabledInput:{
        color: 'black',
        opacity:1,
        fontWeight: 500,
    },
    disableCalendarIcon:{
        '&::-webkit-calendar-picker-indicator':{
            display:'none'
        },
    },
    icon:{
        backgroundColor:'white',
    }
}));